<template>
  <div class="main_container">
    <div class="success_top">
      <slot name="successtop" />
      <div class="bg_middle">
        <img src="./images/h5_bg_top_success@2x.png" />
      </div>
    </div>
    <div class="gift_desc">
      <div class="gift_main">
        <div class="gift-box">
          <slot name="successmain" />
        </div>
      </div>
      <div class="bg_bottom">
        <img src="./images/h5_bg_bottom_success@2x.png" />
      </div>
    </div>

    <div v-if="bottomShow" class="foot_area">
      <slot name="bottombtn" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bottomShow: Boolean
  }
};
</script>

<style lang="stylus" scoped>
.main_container {
  background #F8F8FA;

  .success_top {
    background url('./images/h5_payment_bg_success@2x.png') no-repeat center;
    background-size 375px 100%;
    text-align center;
    overflow: hidden;
    position: relative;
    padding-bottom 50px;
    max-height 236px;

    .bg_middle {
      width 375px;
      height 20px;
      position absolute;
      bottom 16px;
      left 50%;
      transform translate(-50%,0);

      img {
        width 100%
      }
    }
  }

  .bg_bottom {
    width 375px;
    margin 0 auto
    img {
      width 100%
    }
  }

  .gift_desc {
    width 375px;
    margin 0 auto;
    position: relative;
    top: -17px;
    overflow hidden;
    text-align center

    .gift_main {
      width 100%;
      background url('./images/h5_bg_middle_success@2x.png') center bottom;
      background-size 375px 100%;
      .gift-box {
        width 315px;
        box-sizing border-box
        // background #000
        margin 0 auto
        padding 20px
        overflow hidden
      }
    }



  }



  .foot_area {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0.09rem 0.2rem;
    background-color: #fff;
  }
}
</style>